import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

import appointmentsRoutes from "./routes/appointments";
import authRoutes from "./routes/auth";
import baseRoutes from "./routes/base";
import checksRoutes from "./routes/checks";
import creditsRoutes from "./routes/credits";
import customersRoutes from "./routes/customers";
import deliveriesRoutes from "./routes/deliveries";
import depositsRoutes from "./routes/deposits";
import discountsRoutes from "./routes/discounts";
import employeesRoutes from "./routes/employees";
import expensesRoutes from "./routes/expenses";
import invoicesRoutes from "./routes/invoices";
import itemsRoutes from "./routes/items";
import ordersRoutes from "./routes/orders";
import consignmentsRoutes from "./routes/consignments";
import paymentsRoutes from "./routes/payments";
import purchasesRoutes from "./routes/purchases";
import repairsRoutes from "./routes/repairs";
import reportsRoutes from "./routes/reports";
import salesRoutes from "./routes/sales";
import sectionsRoutes from "./routes/sections";
import servicesRoutes from "./routes/services";
import sharesRoutes from "./routes/shares";
import societiesRoutes from "./routes/societies";
import statisticsRoutes from "./routes/statistics";
import stocksRoutes from "./routes/stocks";
import suppliersRoutes from "./routes/suppliers";
import transactionsRoutes from "./routes/transactions";
import updatesRoutes from "./routes/updates";
import usersRoutes from "./routes/users";
import vehiclesRoutes from "./routes/vehicles";
import sellerCustomersRoutes from "./routes/sellerCustomers";
import sellerSalesRoutes from "./routes/sellerSales";
import sellerPaymentsRoutes from "./routes/sellerPayments";
import sellersRoutes from "./routes/sellers";
import notificationsRoutes from "./routes/notifications";
import costsRoutes from "./routes/costs";

const routes = [
  ...appointmentsRoutes,
  ...authRoutes,
  ...baseRoutes,
  ...checksRoutes,
  ...creditsRoutes,
  ...customersRoutes,
  ...deliveriesRoutes,
  ...depositsRoutes,
  ...discountsRoutes,
  ...employeesRoutes,
  ...expensesRoutes,
  ...invoicesRoutes,
  ...itemsRoutes,
  ...ordersRoutes,
  ...consignmentsRoutes,
  ...paymentsRoutes,
  ...purchasesRoutes,
  ...repairsRoutes,
  ...reportsRoutes,
  ...salesRoutes,
  ...sectionsRoutes,
  ...servicesRoutes,
  ...sharesRoutes,
  ...societiesRoutes,
  ...statisticsRoutes,
  ...stocksRoutes,
  ...suppliersRoutes,
  ...transactionsRoutes,
  ...updatesRoutes,
  ...usersRoutes,
  ...vehiclesRoutes,
  ...sellerCustomersRoutes,
  ...sellerSalesRoutes,
  ...sellerPaymentsRoutes,
  ...sellersRoutes,
  ...notificationsRoutes,
  ...costsRoutes,

  //  quotations  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Devis",
      layout: "dashboard",
    },
    path: "/quotations",
    name: "quotations",
    component: () => import("../layouts/index/QuotationIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Devis",
          layout: "dashboard",
        },
        path: "index",
        name: "quotations-index",
        component: () => import("../views/quotations/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Details Devis",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "quotations-details",
        component: () => import("../views/quotations/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre le devis",
          layout: "dashboard",
        },
        path: "create",
        name: "quotations-create",
        component: () => import("../views/quotations/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "L'ajout des articles d'un devis",
          layout: "dashboard",
        },
        path: "items/create",
        name: "quotations-items-create",
        component: () => import("../views/quotations/items/Create.vue"),
      },
    ],
  },

  //  productions  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "productions",
      layout: "dashboard",
    },
    path: "/productions",
    name: "productions",
    component: () => import("../layouts/index/ProductionIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Productions",
          layout: "dashboard",
        },
        path: "index",
        name: "productions-index",
        component: () => import("../views/productions/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre la commande",
          layout: "dashboard",
        },
        path: "create",
        name: "productions-create",
        component: () => import("../views/productions/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Saisir les articles pour réaliser une production",
          layout: "dashboard",
        },
        path: "items/create",
        name: "productions-items-create",
        component: () => import("../views/productions/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails sur la facturation.",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "productions-details",
        component: () => import("../views/productions/Details.vue"),
      },
    ],
  },

  //  raw-materials  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "raw-materials",
      layout: "dashboard",
    },
    path: "/raw-materials",
    name: "raw-materials",
    component: () => import("../layouts/index/RawMaterialIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Matière Première",
          layout: "dashboard",
        },
        path: "index",
        name: "raw-materials-index",
        component: () => import("../views/raw-materials/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre un commande de matières premières",
          layout: "dashboard",
        },
        path: "create",
        name: "raw-materials-create",
        component: () => import("../views/raw-materials/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails d'une commande de matières premières",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "raw-materials-details",
        component: () => import("../views/raw-materials/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "L'ajout des articles à un achat",
          layout: "dashboard",
        },
        path: "items/create",
        name: "raw-materials-items-create",
        component: () => import("../views/raw-materials/items/Create.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function guard(to, from, next, authData, userRole) {
  // console.log(authData);
  if (to.meta && to.meta.is_auth == true) {
    if (authData != null && authData.reference != undefined) {
      if (to.meta.is_repair == true && userRole == "Reparation") {
        return next();
      }
      if (to.meta.is_admin == true) {
        if (userRole != null) {
          if (userRole == "Admin") {
            return next();
          } else if (userRole == "Magasinier") {
            return next();
            // return next({ name: "storekeepe-unauthorized" });
          } else if (userRole == "Caissier") {
            return next();
            // return next({ name: "cashier-unauthorized" });
          } else if (userRole == "Importation") {
            return next();
          } else if (userRole == "IT") {
            return next();
          } else if (userRole == "Commercial") {
            return next();
          } else if (userRole == "Comptable") {
            return next();
          } else if (userRole == "Aide Comptable") {
            return next();
          }
        }
      } else {
        /*if (userRole != null) {
          if (to.meta.is_storekeeper == true) {
            if (userRole == "Admin") {
              return next();
            } else if (userRole == "Magasinier") {
              return next();
            } else if (userRole == "Caissier") {
              return next({ name: "cashier-unauthorized" });
            }
          } else if (to.meta.is_cashier == true) {
            if (userRole == "Admin") {
              return next();
            } else if (userRole == "Caissier") {
              return next();
            } else if (userRole == "Magasinier") {
              return next({ name: "storekeepe-unauthorized" });
            }
          } else if (to.meta.is_viewer == true) {
            if (userRole == "Admin") {
              return next();
            } else if (userRole == "Observateur") {
              return next();
            } else if (userRole == "Caissier") {
              // return next();
            } else if (userRole == "Magasinier") {
              // return next({ name: "storekeepe-unauthorized" });
            }
          } else if (to.meta.is_ecommerce_admin == true) {
            if (userRole == "Admin") {
              return next();
            } else if (userRole == "Ecommerce Admin") {
              return next();
            } else if (userRole == "Caissier") {
              // return next();
            } else if (userRole == "Magasinier") {
              // return next({ name: "storekeepe-unauthorized" });
            }
          }
        }*/
      }
    }
  }
  if (to.name == "login") {
    console.log("route login");
    return next();
  }
  next();
}

router.beforeEach((to, from, next) => {
  let authData = store.getters["auth/getAuthData"];
  let userRole = store.getters["auth/getUserRole"];
  return guard(to, from, next, authData, userRole);
});

export default router;
